async function d({
  appId: i,
  engagementApiUrl: c,
  signal: o,
  timeoutMs: a = 1500
}) {
  if (!i || !c || o?.aborted) return null;
  const s = new AbortController(), u = setTimeout(() => s.abort(), a), l = () => s.abort();
  o?.addEventListener("abort", l, { once: !0 });
  try {
    const t = `${c.replace(/\/$/, "")}/widget/v1/apps/${encodeURIComponent(i)}/design`, n = await fetch(t, {
      signal: s.signal,
      headers: { Accept: "application/json" }
    });
    if (n.status === 404) return null;
    if (!n.ok)
      return console.warn(
        `[pype] widget design fetch failed (${n.status} ${n.statusText})`
      ), null;
    const e = await n.json(), r = e && typeof e == "object" && "config" in e && e.config ? e.config : e;
    return !r?.design || !r?.shell || !r?.branding ? (console.warn("[pype] widget design response missing required sections"), null) : r;
  } catch (t) {
    return t?.name === "AbortError" || console.warn("[pype] widget design fetch errored:", t), null;
  } finally {
    clearTimeout(u), o?.removeEventListener("abort", l);
  }
}
export {
  d as fetchWidgetAppDesign
};
//# sourceMappingURL=fetch-widget-app-design-oe6m_9h2.js.map
